import { queryOptions } from '@tanstack/react-query'
import { dashboardClient } from '@/api'

export const myLeadQueryOptions = () =>
  queryOptions({
    queryKey: ['my-lead'],
    queryFn: () => dashboardClient.v1.getMyLead().then(r => r.data),
  })
